module.exports = __webpack_public_path__ + "static/media/news_back.1341f2d9.svg";